// client/src/services/packs.service.js
import api from './api';

// Get user's packs
export const getUserPacks = async () => {
  const response = await api.get('/packs/me');
  return response.data;
};

// Get pack by ID
export const getPackById = async (packId, isPreviewMode = false) => {
  const url = isPreviewMode
    ? `/packs/${packId}?preview=true`
    : `/packs/${packId}`;
  const response = await api.get(url);
  return response.data;
};

// Create new pack
export const createPack = async (packData) => {
  // --- MODIFICACIÓN ---
  // Ya no se espera FormData, sino un objeto JSON con los metadatos del pack.
  if (packData instanceof FormData) {
    throw new Error(
      'createPack obsoleto. La subida de FormData ya no se maneja aquí.'
    );
  }
  // La llamada a la API ahora envía JSON
  const response = await api.post('/packs', packData);
  return response.data;
};

// Update pack
export const updatePack = async (packId, packData) => {
  // --- MODIFICACIÓN ---
  // Ya no se espera FormData. Se envía JSON con los metadatos.
  if (packData instanceof FormData) {
    throw new Error(
      'updatePack obsoleto. La subida de FormData ya no se maneja aquí.'
    );
  }
  // Se elimina onUploadProgress y headers.
  const response = await api.put(`/packs/${packId}`, packData);
  return response.data;
};

// Delete pack
export const deletePack = async (packId) => {
  const response = await api.delete(`/packs/${packId}`);
  return response.data;
};

// Get public packs by username
export const getPublicPacksByUsername = async (username) => {
  const response = await api.get(`/packs/user/${username}`);
  return response.data;
};

// --- FUNCIÓN OBSOLETA ELIMINADA ---
// export const addItemToPack = ...

// Remove item from pack
export const removeItemFromPack = async (packId, itemId) => {
  // --- MODIFICACIÓN: Usar itemId en lugar de itemIndex ---
  const response = await api.delete(`/packs/${packId}/items/${itemId}`);
  return response.data;
};

// Update premium settings for a pack
export const updatePackPremiumSettings = async (packId, premiumSettings) => {
  const response = await api.put(`/packs/${packId}/premium`, premiumSettings);
  return response.data;
};

// Check if user has access to premium content
export const checkPremiumAccess = async (packId) => {
  try {
    const response = await api.get(`/packs/${packId}/access`);
    return response.data;
  } catch (error) {
    return {
      hasAccess: false,
      error: error.response?.data?.message || 'Error',
    };
  }
};

// Get available effects
export const getAvailableEffects = async () => {
  const response = await api.get('/packs/effects/available');
  return response.data;
};

// Change effect for a specific item
export const changeItemEffect = async (
  packId,
  itemId, // --- MODIFICACIÓN: Recibe itemId ---
  effectType,
  effectIntensity
) => {
  // --- MODIFICACIÓN: El endpoint cambia y se envía el itemId en el body ---
  const response = await api.put(`/packs/${packId}/item-effect`, {
    itemId,
    effectType,
    effectIntensity,
  });
  return response.data;
};

// Get pack price for user
export const getPackPrice = async (packId) => {
  const { data } = await api.get(`/packs/${packId}/price`);
  return data;
};

export const removePackCover = async (packId) => {
  const response = await api.delete(`/packs/${packId}/cover`);
  return response.data;
};

export const reportPack = async (packId, reason) => {
  const response = await api.post(`/packs/${packId}/report`, { reason });
  return response.data;
};
